export default "__VITE_ASSET__Cw1cfIKU__"